module.exports = __webpack_public_path__ + "static/img/ind3.ac74d5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indicadores/ind3.png
// module id = pg7M
// module chunks = 3